<template>
    <section class="account-delete">
        <app-confirmation title="Delete Account"
                          class="account-delete_confirmation"
                          confirm-text="Delete"
                          confirm-icon-class="far fa-trash-alt"
                          @cancel="onCancel"
                          @confirm="deleteAccountAsync">
            <p class="account-delete__confirmation__text">
                This will delete your user account, including all personal information, and then log you out of the application. Are you sure you want to do this?
            </p>
            <hh-error-display :error="error" />
        </app-confirmation>
    </section>
</template>

<script>

import AuthManager from '@/auth/auth-manager'

import AppConfirmation from '@/components/app-core/app-confirmation'

export default {

    data() {
        return {
            error: null,
        }
    },

    methods: {

        onCancel(ev) {
            this.$eventbus.$emit(this.$appevents.hideModal, ev)
        },

        async deleteAccountAsync(ev) {
            try {
                await AuthManager.deleteAccountAsync()
                this.$eventbus.$emit(this.$appevents.hideModal, ev)
                AuthManager.startAtAppropriateRouteForStateAsync()
            } catch (err) {
                this.error = `User account deletion failed: ${ err.message }`
                throw err
            }
        },
    },

    components: {
        AppConfirmation,
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\my-account\modals\_account-delete-confirmation.scss

.account-delete {

    @include element('confirmation') {

        @include element('text') {
            text-align: center;
        }
    }

    @include element('buttons') {
        padding-top: 10px;
        width: 100%;
        display: flex;
    }
}

</style>
